// Global state to track which component is active
let activeComponent = null;
let lastHeaderScheme = "default";

document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("main-header");
  // Mobile menu functionality
  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const mobileMenuDropdown = document.getElementById("mobile-menu-dropdown");

  // Mobile search functionality
  const searchBtn = document.getElementById("search-btn");
  const closeSearchBtn = document.querySelector("[data-close-search]");
  const searchPopup = document.getElementById("header__search");
  const searchForm = searchPopup?.querySelector(".header__search-form");
  const searchInput = searchPopup?.querySelector(".header__search-input");

  // Cart Drawer
  const cartDrawer = document.getElementById("cart-drawer");

  // Controlling Main overlay
  const mainOverlay = document.querySelector(".main__overlay");

  // Open/Close Menu
  const toggleMenu = () => {
    const isOpening = !mobileMenuBtn.classList.contains("active");

    mobileMenuBtn.classList.toggle("active");
    mobileMenuDropdown.classList.toggle("active");

    const submenu = mobileMenuDropdown.querySelector(
      ".mobile-hidden-menu.show"
    );
    if (submenu) {
      submenu.classList.remove("show");
    }

    if (isOpening) {
      if (activeComponent === "search") closeSearch();
      if (activeComponent === "cart") closeCartDrawer();

      mainOverlay.addEventListener("click", toggleMenu);
      activeComponent = "menu";

      if (HeaderControl.isTransparent) {
        lastHeaderScheme = HeaderControl.getMode();
        HeaderControl.setMode();
      }
    } else {
      // Remove overlay click handler when closing
      mainOverlay.removeEventListener("click", toggleMenu);
      activeComponent = null;

      if (HeaderControl.isTransparent) {
        HeaderControl.setMode(lastHeaderScheme);
      }
    }

    if (mainOverlay.classList.contains("active")) {
      mainOverlay.classList.remove("active");
      resetOverlay();
    } else {
      mainOverlay.classList.add("active");
      adjustOverlay();
    }

    document.body.style.overflow = mobileMenuBtn.classList.contains("active")
      ? "hidden"
      : "";
  };

  // Keep track of overlay click handler
  let overlayClickHandler = null;

  const searchTl = gsap
    .timeline({ paused: true, duration: 0.3, ease: "power2.out" })
    .addLabel("open")
    .to(searchPopup, { opacity: 1 })
    .from(searchForm, { y: "4rem", opacity: 0 }, "<= .15")
    .addLabel("close")
    .to(searchForm, { y: "-4rem", opacity: 0 }, "close")
    .to(searchPopup, { opacity: 0 }, "close+=0.15");

  const showSearch = () => {
    if (activeComponent === "search") return;
    if (activeComponent === "cart") closeCartDrawer();
    if (activeComponent === "menu") toggleMenu();

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    // Use requestAnimationFrame for smoother animation
    searchBtn.classList.add("active");
    searchPopup.classList.add("active");
    searchInput.focus();
    activeComponent = "search";

    // 🎞 Play only the "open" part of timeline
    searchTl.tweenFromTo("open", "close");

    if (HeaderControl.isTransparent) {
      lastHeaderScheme = HeaderControl.getMode();
      HeaderControl.setMode();
    }
  };

  // ❌ Close search (play close animation)
  const closeSearch = () => {
    if (!searchPopup.classList.contains("active")) return;

    if (HeaderControl.isTransparent) {
      HeaderControl.setMode(lastHeaderScheme);
    }

    // 🎞 Play only the "close" part
    searchTl.tweenFromTo("close", searchTl.duration());

    // 🧹 Cleanup after animation ends
    searchTl.eventCallback("onComplete", () => {
      searchBtn.classList.remove("active");
      searchPopup.classList.remove("active");
      searchInput.value = "";
      document.body.style.overflow = "";
      activeComponent = null;

      // Remove callback so it doesn't fire next time
      searchTl.eventCallback("onComplete", null);
    });
  };

  // Initialize Menu Drawer event listeners
  if (mobileMenuBtn && mobileMenuDropdown) {
    mobileMenuBtn.addEventListener("click", toggleMenu);

    const mobileMenuCloseMain = document.getElementById(
      "mobile-menu-close-main"
    );
    if (mobileMenuCloseMain) {
      mobileMenuCloseMain.addEventListener("click", toggleMenu);
    }
  }

  // Initialize Search Drawer event listeners
  if (searchBtn && searchPopup) {
    searchBtn.addEventListener("click", () => {
      activeComponent === "search" ? closeSearch() : showSearch();
    });
    closeSearchBtn.addEventListener("click", closeSearch);
  }

  //Open Cart Drawer
  const openCartDrawer = () => {
    if (cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.add("open");
    mainOverlay.classList.add("active");

    if (activeComponent === "search") closeSearch();
    if (activeComponent === "menu") toggleMenu();

    activeComponent = "cart";

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    // Set header state if not fixed
    if (HeaderControl.isTransparent) {
      lastHeaderScheme = HeaderControl.getMode();
      HeaderControl.setMode();
    }

    // Add overlay click handler only once
    if (!overlayClickHandler) {
      overlayClickHandler = (e) => {
        if (e.target === mainOverlay) {
          closeCartDrawer();
        }
      };
      mainOverlay.addEventListener("click", overlayClickHandler);
    }
  };

  //Close Cart Drawer
  const closeCartDrawer = () => {
    if (!cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.remove("open");
    mainOverlay.classList.remove("active");
    document.body.style.overflow = "";
    activeComponent = null;

    if (HeaderControl.isTransparent) {
      HeaderControl.setMode(lastHeaderScheme);
    }

    // Remove overlay click handler
    if (overlayClickHandler) {
      mainOverlay.removeEventListener("click", overlayClickHandler);
      overlayClickHandler = null;
    }
  };

  // Close search when clicking outside (header/announcement)
  document.addEventListener("mousedown", (e) => {
    if (activeComponent !== "search") return;

    const searchElements = [
      document.querySelector(".header__search-container"),
      document.getElementById("search-btn"),
    ];

    const clickedInsideSearch = searchElements.some(
      (el) => el && (el === e.target || el.contains(e.target))
    );

    if (!clickedInsideSearch) {
      closeSearch(header.contains(e.target));
    }
  });

  // Modified escape key handler
  const handleEscapeKey = (e) => {
    if (e.key === "Escape") {
      if (activeComponent === "menu") {
        toggleMenu();
      } else if (activeComponent === "search") {
        closeSearch();
      } else if (activeComponent === "cart") {
        closeCartDrawer();
      } else if (activeComponent === "video-popup") {
        closeVideoPopup();
      } else if (activeComponent === "filter") {
        closeFilterDrawer();
      }
    }
  };

  // Add escape key listener once
  document.addEventListener("keydown", handleEscapeKey);

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.activeComponent = activeComponent;

  window.openFilterDrawer = openFilterDrawer;
  window.closeFilterDrawer = closeFilterDrawer;

  window.openLocalization = openLocalization;
  window.closeLocalization = closeLocalization;

  window.toggleMenu = toggleMenu;
});

const closeAllPopups = (activeComponent) => {
  if (activeComponent === "localization") {
    closeCartDrawer();
    closeFilterDrawer();
    closeSearch();
    closeVideoPopup();

    const mobileMenuBtn = document.getElementById("mobile-menu-btn");
    if (mobileMenuBtn.classList.contains("active")) toggleMenu();
  }
};

const openFilterDrawer = () => {
  const filterDrawer = document.querySelector(".filters-drawer");
  if (!filterDrawer) return;

  filterDrawer.classList.add("open");
  document.body.style.overflow = "hidden";
  mainOverlay.classList.add("active");
  mainOverlay.addEventListener("click", closeFilterDrawer);
  activeComponent = "filter";
};

const closeFilterDrawer = () => {
  const filterDrawer = document.querySelector(".filters-drawer");
  if (!filterDrawer) return;

  filterDrawer.classList.remove("open");
  document.body.style.overflow = "";
  mainOverlay.classList.remove("active");

  mainOverlay.removeEventListener("click", closeFilterDrawer);
  activeComponent = null;

  const container = document.querySelector(".collection-grid-container");
  if (container) {
    container.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

//------------------------------------------------------Localization

const LOCALIZATION_TIMER_KEY = "localizationTimer";
const LOCALIZATION_TIMER_DURATION = 360000; // 1 hour in milliseconds
let localizationId;

// Open localization menu
const openLocalization = () => {
  clearTimeout(localizationId);
  const localizationMenu = document.getElementById("localization-menu");
  if (!localizationMenu) console.log("localizationMenu not found in open");

  if (document.body.classList.contains("has-localization")) {
    closeLocalization();
  } else {
    // Reset the timer whenever manually opened
    localStorage.removeItem(LOCALIZATION_TIMER_KEY);

    activeComponent = "localization";
    closeAllPopups();
    localizationMenu.classList.remove("hiding");
    document.body.classList.add("has-localization");

    // Update button state
    document
      .getElementById("localization-button")
      .setAttribute("aria-expanded", "true");

    localizationMenu.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  }
};

// Close localization menu
const closeLocalization = (type) => {
  const localizationMenu = document.getElementById("localization-menu");
  if (!localizationMenu) console.log("localizationMenu not found in close");

  // Start the timer when closed
  localStorage.setItem(LOCALIZATION_TIMER_KEY, Date.now().toString());
  document
    .getElementById("localization-button")
    .setAttribute("aria-expanded", "false");

  if (type === "close") {
    localizationMenu.classList.add("hiding");
  }

  localizationId = setTimeout(() => {
    document.body.classList.remove("has-localization");
  }, 300);
};
